import { Link } from "react-router-dom";
import { IoAddSharp } from "react-icons/io5";

export function AddLink({ to, title = "Agregar", size = "md" }) {
  return (
    <Link className={`btn btn-${size} btn-success`} to={to}>
      <span>{title}</span>
      <IoAddSharp className="ms-1" />
    </Link>
  );
}
